/* eslint-disable react/no-unescaped-entities */
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { useStore } from '@/providers/app-store-provider';
import { EPlatform } from '@/utils/enums/platform-enum';
import Image from 'next/image';
import Link from 'next/link';
import { useContext, useEffect } from 'react';

// 法语静态内容组件
export default function FrenchContent() {
  // const supportEmail = env.NEXT_PUBLIC_SUPPORT_EMAIL;
  const { deviceType } = useContext(ResponsiveContext);
  const setIsShowFooterNav = useStore((state) => state.setIsShowFooterNav);

  useEffect(() => {
    const isMobile = deviceType !== EPlatform.WEB;
    isMobile && setIsShowFooterNav(false);
  }, [deviceType]);
  return (
    <>
      <WebOnly>
        <div className="w-full py-[50px] px-[200px] text-[14px] font-ir">
          <div className="relative mb-[50px]">
            <Image
              src="https://cdn.shoplazza.com/0cd6beca837fe4835e8053a631fdcbc5.jpeg"
              alt="Retour et remboursement"
              width={800}
              height={400}
              className="w-full"
            />
            <h1 className="absolute top-1/2 left-1/2 w-full transform -translate-x-1/2 -translate-y-full text-center text-[36px] text-white font-bb">
              <span>Retour &amp; Remboursement</span>
            </h1>
          </div>
          <p className="text-left my-[25px] leading-[24px]">
            <span>Notre promesse: Votre satisfaction avant tout</span>
            <br />

            <span>
              Chez Zeelool, notre priorité est de vous offrir des lunettes parfaitement adaptées au
              meilleur tarif. Si vous rencontrez le moindre souci sur votre commande, contactez-nous
              immédiatement.
            </span>
          </p>

          <div>
            <h3 className="mb-[20px] text-[20px]">Aperçu des politiques après-vente</h3>

            <p className=" mx-auto leading-[24px]">
              ● Période principale de réclamation: 30 jours après réception (tels que soucis liés à
              l’ordonnance, erreur de livraison, casse durant le transport, etc.)
            </p>
            <p className=" mx-auto leading-[24px]">
              ● Garantie étendue sur les défauts de fabrication: 365 jours après réception
            </p>
            <p className=" mx-auto leading-[24px]">
              ● Important: Les lunettes de vue sont fabriquées sur mesure, toute modification ou
              annulation de commande entraîne des frais.
            </p>

            <p className="mt-[20px] mx-auto leading-[24px]">
              Tous les articles de lunetterie vendus sur notre site sont personnalisés selon vos
              choix individuels, et leur fabrication commence dès la confirmation de la commande.{' '}
              <span className="font-bb">
                En règle générale, les produits personnalisés sont exclus du droit de rétractation
                légal (période de réflexion) applicable aux contrats à distance.
              </span>
            </p>
            <p className="mt-[20px] mx-auto leading-[24px]">
              Cependant, nous vous offrons volontairement un délai de retour plus généreux de{' '}
              <span className="font-bb">30 jours</span> à compter de la date de réception de vos
              articles. Si vous souhaitez retourner vos lunettes personnalisées, veuillez contacter
              notre service client par e-mail à l'adresse support@fr.zeelool.com. Nous vous
              répondrons sous 24 heures et vous guiderons tout au long du processus de retour.
            </p>

            <h3 className="mb-[12px] mt-[20px] text-[20px]">
              1. Problème de vue ou de prescription (30 jours) 👓
            </h3>
            <p className=" mx-auto leading-[24px]">
              <span className="font-bb">Erreur de notre part: </span> Si les verres ne correspondent
              pas aux paramètres de votre ordonnance fournis, après vérification, deux solutions
              gratuites au choix :
            </p>
            <p className=" mx-auto leading-[24px]">● Remplacement intégral des verres</p>
            <p className=" mx-auto leading-[24px]">● Remboursement total de la commande</p>

            <p className="mt-[20px] mx-auto leading-[24px]">
              <span className="font-bb">Erreur de saisie: </span>Si vous avez renseigné une mauvaise
              correction lors de la commande, nous vous proposons une compensation :
            </p>
            <p className=" mx-auto leading-[24px]">
              ● Remplacement intégral des verres（tout écart de tarif devra être réglé par vos
              soins）
            </p>
            <p className=" mx-auto leading-[24px]">
              ● Remboursement total de la commande, hors frais de livraison
            </p>

            <h3 className="mt-[20px] text-[20px]">
              2. Erreur de modèle ou perte de colis (entièrement gratuit) 📦
            </h3>
            <p className=" mx-auto leading-[24px]">
              ● <span className="font-bb">Mauvais article reçu:</span> Réception d’une paire non
              conforme à votre commande. Envoyez-nous simplement des photos du produit reçu. Nous
              vous expédions gratuitement la bonne référence, et vous gardez la paire erronée sans
              devoir la renvoyer.
            </p>
            <p className=" mx-auto leading-[24px]">
              ● <span className="font-bb">Colis perdu:</span> Si le transporteur confirme la perte
              du colis ou que le suivi reste figé sans mise à jour, nous renvoyons votre commande
              sans frais ni conditions.
            </p>

            <h3 className="mt-[20px] text-[20px]">
              3. Lunettes endommagées ou défaut de fabrication 🛠️
            </h3>
            <p className=" mx-auto leading-[24px]">
              ● <span className="font-bb">Dommages survenus pendant le transport: </span> Si vos
              lunettes arrivent cassées à l’ouverture du colis, nous mettons en place immédiatement
              un remplacement gratuit.
            </p>
            <p className=" mx-auto leading-[24px]">
              ● <span className="font-bb">Défaut hors usure normale: </span>Tout vice constaté dans
              les 365 jours et non lié à l’usage quotidien donne droit à une réexpédition sans
              frais.
            </p>

            <h3 className="mb-[12px] mt-[20px] text-[20px]">
              4. Modification ou annulation de commande ✏️
            </h3>
            <p className=" mx-auto leading-[24px]">
              Chaque paire de lunettes étant personnalisée selon votre vue, toute modification ou
              annulation entraîne des frais spécifiques liés à la taille des verres déjà entamée.
            </p>

            <h3 className="mt-[12px] text-[20px]">
              Tableau des frais de modification / annulation
            </h3>

            <table className="my-[20px] mx-auto border-collapse border-spacing-0 w-[755px] border border-[#dddddd]">
              <tbody>
                <tr className="bg-[#eaedf6]">
                  <td className="bg-[#d6dae5] border border-[#dddddd] text-center h-[60px] align-middle break-words w-[116px]" />
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[180px]">
                    Avant expédition (en cours de traitement)
                  </td>
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[459px]">
                    Après expédition
                  </td>
                </tr>
                <tr>
                  <td className=" border border-[#dddddd] text-center h-[60px] align-middle break-words w-[116px]">
                    Montures et accessoires
                  </td>
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[180px]">
                    Gratuit
                  </td>
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[459px]">
                    30 % du total de la commande
                  </td>
                </tr>
                <tr>
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[116px]">
                    Lunettes de vue
                  </td>
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[180px]">
                    10 % du total de la commande
                  </td>
                  <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[459px]">
                    30 % du total de la commande
                  </td>
                </tr>
              </tbody>
            </table>

            <p className="mb-[80px] mx-auto leading-[24px]">
              <span>Note :&nbsp;</span>Ici, vous pouvez suivre l&#39;état de votre commande -
              <span>&nbsp;</span>
              <Link href="/track-order" className="text-[#3c65c8]">
                Suivi de commande
              </Link>
            </p>

            <div className="flex items-stretch">
              <div className="left relative min-h-[545px] w-[427px] flex-shrink-0 overflow-hidden bg-[#d3d3d3]">
                <Image
                  src="https://cdn.shoplazza.com/d61e587bf685b52067ff941266eef9be.jpeg"
                  alt="Procédure de retour"
                  fill
                  sizes="427px"
                  className="object-cover object-center"
                />
              </div>
              <div className="flex flex-col justify-center w-[calc(100%-427px)] leading-[21px] text-[14px] text-[#282828] font-br font-normal bg-[#f4f6f8] p-[48px_48px] box-border">
                <h3 className="mb-[32px] text-[20px] font-bb">
                  <span>Procédure de Retour: Comment faire ?</span>
                </h3>
                <div>
                  <p className="m-0">Conditions obligatoires pour valider un retour</p>
                  <p className="m-0">
                    · La demande de retour doit être transmise dans les 30 jours suivant la
                    réception du colis
                  </p>
                  <p className="m-0">
                    · Les articles renvoyés doivent être dans leur état d’origine, jamais portés
                  </p>
                </div>
                <div className="mt-[16px]">
                  <p className="m-0">Étape 1: Contacter le service client</p>
                  <p className="m-0">
                    · Envoyez un courriel à <span className="font-bb">support@fr.zeelool.com</span>.
                  </p>
                  <p className="m-0">
                    · Si votre demande concerne un défaut de vue, joignez une copie de votre
                    ordonnance pour que nos opticiens puissent vérifier vos paramètres visuels.
                  </p>
                </div>
                <div className="mt-[16px]">
                  <p className="m-0">Étape 2: Préparer le colis de retour</p>
                  <p className="m-0">· Emballez soigneusement vos lunettes.</p>
                  <p className="m-0">
                    · Ajoutez une feuille dans le colis avec votre nom, votre numéro de commande et
                    la raison du retour.
                  </p>
                </div>
                <div className="mt-[16px]">
                  <p className="m-0">Étape 3: Expédier avec un suivi traçable</p>
                  <p className="m-0">
                    · Nous vous recommandons de choisir un transporteur avec numéro de suivi.
                  </p>
                  <p className="m-0">
                    · Zeelool ne peut pas être tenu responsable en cas de perte du colis pendant le
                    transport.
                  </p>
                  <p className="m-0">
                    · Une fois l’envoi réalisé, communiquez-nous votre numéro de suivi.
                  </p>
                </div>
                <div className="mt-[16px]">
                  <p className="m-0">Étape 4: Traitement du remboursement</p>
                  <p className="m-0">
                    · Dès réception et contrôle de votre colis par nos équipes, le remboursement
                    sera effectué dans un délai de 3 jours ouvrés.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </WebOnly>

      <WapOnly>
        <div className="px-[16px]">
          <div className="text-[14px] font-ir">
            <div className="container">
              <p className="my-[20px] leading-[1.5]">
                <span>Notre promesse: Votre satisfaction avant tout</span>
                <br />
                <br />
                <span>
                  Chez Zeelool, notre priorité est de vous offrir des lunettes parfaitement adaptées
                  au meilleur tarif. Si vous rencontrez le moindre souci sur votre commande,
                  contactez-nous immédiatement.
                </span>
              </p>

              <p className="mb-[20px] font-bb">Aperçu des politiques après-vente</p>
              <p className="mb-[20px]">
                ● Période principale de réclamation: 30 jours après réception (tels que soucis liés
                à l’ordonnance, erreur de livraison, casse durant le transport, etc.)
              </p>
              <p className="mb-[20px]">
                ● Garantie étendue sur les défauts de fabrication: 365 jours après réception
              </p>
              <p className="mb-[20px]">
                ● Important: Les lunettes de vue sont fabriquées sur mesure, toute modification ou
                annulation de commande entraîne des frais.
              </p>

              <p className="mb-[20px]">
                Tous les articles de lunetterie vendus sur notre site sont personnalisés selon vos
                choix individuels, et leur fabrication commence dès la confirmation de la commande.
                <span className="font-bb">
                  {' '}
                  En règle générale, les produits personnalisés sont exclus du droit de rétractation
                  légal (période de réflexion) applicable aux contrats à distance.
                </span>
              </p>
              <p className="mb-[20px]">
                Cependant, nous vous offrons volontairement un délai de retour plus généreux de{' '}
                <span className="font-bb">30 jours</span> à compter de la date de réception de vos
                articles. Si vous souhaitez retourner vos lunettes personnalisées, veuillez
                contacter notre service client par e-mail à l'adresse support@fr.zeelool.com. Nous
                vous répondrons sous 24 heures et vous guiderons tout au long du processus de
                retour.
              </p>

              <p className="mb-[20px] font-bb">
                1. Problème de vue ou de prescription (30 jours) 👓
              </p>
              <p className="mb-[20px]">
                <span className="font-bb">Erreur de notre part:</span> Si les verres ne
                correspondent pas aux paramètres de votre ordonnance fournis, après vérification,
                deux solutions gratuites au choix :
              </p>
              <p className="mb-[20px]">● Remplacement intégral des verres</p>
              <p className="mb-[20px]">● Remboursement total de la commande</p>

              <p className="mb-[20px]">
                <span className="font-bb">Erreur de saisie:</span> Si vous avez renseigné une
                mauvaise correction lors de la commande, nous vous proposons une compensation :
              </p>
              <p className="mb-[20px]">
                ● Remplacement intégral des verres（tout écart de tarif devra être réglé par vos
                soins）
              </p>
              <p className="mb-[20px]">
                ● Remboursement total de la commande, hors frais de livraison
              </p>

              <p className="mb-[20px] font-bb">
                2. Erreur de modèle ou perte de colis (entièrement gratuit) 📦
              </p>
              <p className="mb-[20px]">
                ● <span className="font-bb">Mauvais article reçu:</span> Réception d’une paire non
                conforme à votre commande. Envoyez-nous simplement des photos du produit reçu. Nous
                vous expédions gratuitement la bonne référence, et vous gardez la paire erronée sans
                devoir la renvoyer.
              </p>
              <p className="mb-[20px]">
                ● <span className="font-bb">Colis perdu:</span> Si le transporteur confirme la perte
                du colis ou que le suivi reste figé sans mise à jour, nous renvoyons votre commande
                sans frais ni conditions.
              </p>

              <p className="mb-[20px] font-bb">
                3. Lunettes endommagées ou défaut de fabrication 🛠️
              </p>
              <p className="mb-[20px]">
                ● <span className="font-bb">Dommages survenus pendant le transport:</span> Si vos
                lunettes arrivent cassées à l’ouverture du colis, nous mettons en place
                immédiatement un remplacement gratuit.
              </p>
              <p className="mb-[20px]">
                ● <span className="font-bb">Défaut hors usure normale:</span> Tout vice constaté
                dans les 365 jours et non lié à l’usage quotidien donne droit à une réexpédition
                sans frais.
              </p>

              <p className="mb-[12px] mt-[40px] font-bb">
                4. Modification ou annulation de commande ✏️
              </p>
              <p className="mb-[20px]">
                Chaque paire de lunettes étant personnalisée selon votre vue, toute modification ou
                annulation entraîne des frais spécifiques liés à la taille des verres déjà entamée.
              </p>

              <p className="mb-[20px] font-bb">Tableau des frais de modification / annulation</p>

              <table className="my-[20px] mx-auto border-collapse border-spacing-0 w-full text-[12px] border border-[#dddddd]">
                <tbody>
                  <tr className="bg-[#eaedf6]">
                    <td className="bg-[#d6dae5] border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]" />
                    <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Avant expédition (en cours de traitement)
                    </td>
                    <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Après expédition
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-[#eaedf6] border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Montures et accessoires
                    </td>
                    <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Gratuit
                    </td>
                    <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      30 % du total de la commande
                    </td>
                  </tr>
                  <tr>
                    <td className="bg-[#eaedf6] border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      Lunettes de vue
                    </td>
                    <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      10 % du total de la commande
                    </td>
                    <td className="border border-[#dddddd] text-center h-[60px] align-middle break-words w-[33.33%] text-[12px]">
                      30 % du total de la commande
                    </td>
                  </tr>
                </tbody>
              </table>

              <p className="leading-[1.5] my-[20px]">
                Note: Ici, vous pouvez suivre l'état de votre commande -
                <Link href="/track-order" className="text-[#3c65c8] font-bb">
                  Suivi de commande
                </Link>
              </p>

              <p className="text-[20px] font-bb">Procédure de Retour: Comment faire ?</p>

              <div className="leading-[1.5] my-[20px]">
                <p className="m-0">Conditions obligatoires pour valider un retour</p>
                <p className="m-0">
                  · La demande de retour doit être transmise dans les 30 jours suivant la réception
                  du colis
                </p>
                <p className="m-0">
                  · Les articles renvoyés doivent être dans leur état d’origine, jamais portés
                </p>
              </div>
              <div className="mb-[20px]">
                <p className="m-0 font-bb">Étape 1: Contacter le service client</p>
                <p className="m-0">
                  · Envoyez un courriel à <span className="font-bb">support@fr.zeelool.com</span>.
                </p>
                <p className="m-0">
                  · Si votre demande concerne un défaut de vue, joignez une copie de votre
                  ordonnance pour que nos opticiens puissent vérifier vos paramètres visuels.
                </p>
              </div>
              <div className="mb-[20px]">
                <p className="m-0 font-bb">Étape 2: Préparer le colis de retour</p>
                <p className="m-0">· Emballez soigneusement vos lunettes.</p>
                <p className="m-0">
                  · Ajoutez une feuille dans le colis avec votre nom, votre numéro de commande et la
                  raison du retour.
                </p>
              </div>
              <div className="mb-[20px]">
                <p className="m-0 font-bb">Étape 3: Expédier avec un suivi traçable</p>
                <p className="m-0">
                  · Nous vous recommandons de choisir un transporteur avec numéro de suivi.
                </p>
                <p className="m-0">
                  · Zeelool ne peut pas être tenu responsable en cas de perte du colis pendant le
                  transport.
                </p>
                <p className="m-0">
                  · Une fois l’envoi réalisé, communiquez-nous votre numéro de suivi.
                </p>
              </div>
              <div className="mb-[20px]">
                <p className="m-0 font-bb">Étape 4: Traitement du remboursement</p>
                <p className="m-0">
                  · Dès réception et contrôle de votre colis par nos équipes, le remboursement sera
                  effectué dans un délai de 3 jours ouvrés.
                </p>
              </div>
            </div>
          </div>
        </div>
      </WapOnly>
    </>
  );
}
